import { ReactElement } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import { InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import TextField, { TextFieldProps } from '@mui/material/TextField';

import { useAppDispatch } from '../../../../../../../../../store/hooks';
import { filterReviewsByDate } from '../../../../../store/slices/slices/reviews.slice';
import { DateInputFieldProps } from './models/date-input-field.props';

export const DateInputField = ({
  dateValue,
  textFieldProps,
  setFieldValue,
}: DateInputFieldProps): ReactElement => {
  const dispatch = useAppDispatch();

  return (
    <TextField
      {...(textFieldProps as TextFieldProps)}
      InputProps={{
        ...textFieldProps.InputProps,
        endAdornment: (
          <>
            {dateValue && (
              <InputAdornment position="end">
                <IconButton
                  sx={{ mr: '-18px' }}
                  onClick={() => {
                    dispatch(filterReviewsByDate(undefined));
                    setFieldValue('date', null);
                  }}
                  edge="end"
                  size="small"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            )}
            {textFieldProps.InputProps?.endAdornment}
          </>
        ),
      }}
    ></TextField>
  );
};
